module.exports = __webpack_public_path__ + "static/media/Trainicon02@3x.5da3a63a.png";